(ns app.components.menus.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]))

(defclass popover-menu
  []
  [:.popover {:border-color "#E0DFE4"}])

(defclass folder-item-menu-box
  [] {:padding "4px 8px"}
  [:.MuiPaper-root {:padding "4px 8px"
                    :border "1px solid #E0DFE4"

                    :border-radius "8px"}]
  [:.MuiMenuItem-root {:border-radius "4px"}]
  [:.Mui-selected
   {:background-color :theme/*purplePrimaryLight*
    :color :theme/*purplePrimary*}])

(defclass workspaces-menu-box
  [menu-id] {:padding "4px 8px"
             :height "400px"
             :margin-left (if (= menu-id "menu-move-to-button") "91px" "127px")}
  [:.MuiPaper-root {:padding "4px 8px"
                    :border "1px solid #E0DFE4"

                    :border-radius "8px"}]
  [:.MuiMenuItem-root {:border-radius "4px"}])

(defclass menu-list-item
  [] {:padding "4px 8px"
      :margin-bottom "4px"})

(defclass empty-menu-list-item
  [] {:padding "4px 8px"
      :margin-bottom "4px"
      :color :theme/*grey400*})


(defclass delete-button
  [] {:color "#FF4975 !important"
      :padding "4px 8px"})

(defclass product-settings-icon
  []
  {:margin-bottom "20px"
   :align-self "center"})
